import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Progress as AntProgress } from 'antd';
import styled from 'styled-components';
var Progress = styled(AntProgress)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-progress-bg {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.colors.primary;
});
export default Progress;